module.exports = __webpack_public_path__ + "img/management-nav-colored.643cc709.svg";